import { render, staticRenderFns } from "./IdentityFail.vue?vue&type=template&id=dc57fa7e&scoped=true"
import script from "./IdentityFail.vue?vue&type=script&lang=js"
export * from "./IdentityFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc57fa7e",
  null
  
)

export default component.exports